import { Component } from "@angular/core";
import { Subject } from "rxjs";

import { DirectSessionLogicService } from "../../shared/direct-session-logic.service";
import { environment } from "../../../environments/environment";


@Component({
    selector: "bs-error-component",
    template: `
        <div class="modal fade" id="bs-error-component" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <img src="{{this.messageIcon}}" class="modal-icon" alt="Error Icon">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{this.messageTitle}}</h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button> -->
                </div>
                <div class="modal-body">
                    <!-- {{this.messageBody}} -->
                    <span>Your payment could not be processed. Please double-check your card number, expiration date, and billing zip code, then try again. If the issue persists, try a different card.</span>
                    <!-- <p>(There should be a reference number and a number to contact an AGENT.)</p> -->
                    <div>
                        <span>If you have questions please call us at: </span>
                        <a href="tel:{{this.callNumber}}">{{this.displayedPhoneNumber}}</a>
                    </div>
                    
                    <span>Please give the representative your Reference Number: </span>
                    <div>{{this.customerId}}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" >Close</button>
                </div>
                </div>
            </div>
        </div>
    `,
    styleUrls: ["./bootstrap-error.component.scss"],
    standalone: true,
    imports: [],
    host: {'class': 'bs-error-component'}
})

export class BootstrapErrorComponent {
    private unsubscriber = new Subject<void>();

    messageTitle: string = "Payment Error";
    messageIcon: string = "assets/Icons/exclamation-circle.svg";
    callNumber: string = "";
    displayedPhoneNumber: string = "";

    get customerId(): string {
        return this.directSessionLogic.trimmedSessionSignal().customerId ?? "[No Reference Number]";
    }

    constructor(
        public directSessionLogic: DirectSessionLogicService,
    ) {
        this.displayedPhoneNumber = environment.CompanyInfo.DisplayedPhoneNumber;
        this.callNumber = "+" + this.displayedPhoneNumber.replace(/\D/g, "");
    }


    // template:string = "After submitting credit card information that failed, I want to see the customer service number and message, ***Payment Failed*** Contact your card issuer for more details, or use a different card/payment method. (There should be a reference number and a number to contact an AGENT.)";
}